import { render, staticRenderFns } from "./NewsComp.vue?vue&type=template&id=29617787&scoped=true&"
import script from "./NewsComp.vue?vue&type=script&lang=js&"
export * from "./NewsComp.vue?vue&type=script&lang=js&"
import style0 from "./NewsComp.vue?vue&type=style&index=0&id=29617787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29617787",
  null
  
)

export default component.exports